import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import FloatingWhatsApp from "../components/common/FloatingWhatsApp";
import ContactFormSection from "../components/contact/ContactFormSection";

const MainLayout = () => {
    const { pathname } = useLocation();

    // Pages where the contact form is already present or not needed
    const hideFormOn = ["/contact-us", "/privacy-policy", "/terms-of-service"];
    const showContactForm = !hideFormOn.includes(pathname);

    return (
        <>
            <Navbar />
            <main>
                <Outlet />
            </main>
            {showContactForm && <ContactFormSection />}
            <Footer />

            {/* Global WhatsApp Button */}
            <FloatingWhatsApp />
        </>
    );
};

export default MainLayout;